import { 
  Instagram, 
  Linkedin, 
  Youtube,
  Mail
} from "lucide-react";

interface SocialMediaLinksProps {
  className?: string;
  iconSize?: string;
  showLabels?: boolean;
  variant?: 'footer' | 'header' | 'contact';
}

const SocialMediaLinks = ({ 
  className = "", 
  iconSize = "h-5 w-5", 
  showLabels = false,
  variant = 'footer'
}: SocialMediaLinksProps) => {
  const socialLinks = [
    {
      name: "Instagram",
      url: "https://instagram.com/eliteedgemc.ae",
      icon: Instagram,
      hoverColor: "hover:text-pink-500",
      label: "@eliteedgemc.ae"
    },
    {
      name: "LinkedIn",
      url: "https://linkedin.com/company/elite-edge-management-consultancy",
      icon: Linkedin,
      hoverColor: "hover:text-blue-500",
      label: "Elite Edge Management Consultancy"
    },
    {
      name: "YouTube",
      url: "https://youtube.com/@EliteEdgemanagementconsultancy",
      icon: Youtube,
      hoverColor: "hover:text-red-500",
      label: "@EliteEdgemanagementconsultancy"
    },
    {
      name: "Email",
      url: "mailto:info@eliteedgemc.ae",
      icon: Mail,
      hoverColor: "hover:text-green-500",
      label: "info@eliteedgemc.ae"
    },
    {
      name: "WhatsApp",
      url: "https://wa.me/971585687738",
      icon: () => (
        <svg className={iconSize} fill="currentColor" viewBox="0 0 24 24">
          <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893A11.821 11.821 0 0020.885 3.488"/>
        </svg>
      ),
      hoverColor: "hover:text-green-600",
      label: "+971585687738"
    }
  ];

  const TikTokIcon = () => (
    <svg className={iconSize} fill="currentColor" viewBox="0 0 24 24">
      <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z"/>
    </svg>
  );

  const baseClasses = variant === 'footer' 
    ? "text-gray-400 transition-colors" 
    : variant === 'header'
    ? "text-muted-foreground transition-colors"
    : "text-primary transition-colors";

  return (
    <div className={`flex items-center space-x-4 ${className}`}>
      {socialLinks.map((social) => {
        const Icon = social.icon;
        return (
          <div key={social.name} className={showLabels ? "flex flex-col items-center space-y-1" : ""}>
            <a
              href={social.url}
              target="_blank"
              rel="noopener noreferrer"
              className={`${baseClasses} ${social.hoverColor}`}
              aria-label={`Follow us on ${social.name}`}
              title={`Follow us on ${social.name}`}
            >
              {typeof social.icon === 'function' ? <social.icon /> : <Icon className={iconSize} />}
            </a>
            {showLabels && (
              <span className="text-xs text-muted-foreground">{social.label}</span>
            )}
          </div>
        );
      })}
      
      {/* TikTok */}
      <div className={showLabels ? "flex flex-col items-center space-y-1" : ""}>
        <a
          href="https://tiktok.com/@elite.edge.manage"
          target="_blank"
          rel="noopener noreferrer"
          className={`${baseClasses} ${variant === 'footer' ? 'hover:text-white' : 'hover:text-black'}`}
          aria-label="Follow us on TikTok"
          title="Follow us on TikTok"
        >
          <TikTokIcon />
        </a>
        {showLabels && (
          <span className="text-xs text-muted-foreground">@elite.edge.manage</span>
        )}
      </div>
    </div>
  );
};

export default SocialMediaLinks;